import sanitizeHtml from "sanitize-html";

import { getHTMLDecodedText } from "util/chatUtil";
import ReactHtmlParser from "react-html-parser";
import { whatsappFormat } from "util/whatsappFormatter";

export const handleSanitizeText = (body) => {
  let msg = body;
  if (!msg) {
    return null;
  }
  msg = msg.replace(/<p[^>]*>/g, "");
  msg = msg.replace(/<\/p[^>]*>/g, "");
  msg = msg.replace(/<br[^>]*>/g, "");
  msg = sanitizeHtml(msg, {
    allowedTags: ["b", "i", "em", "strong"],
  });
  msg = getHTMLDecodedText(msg);
  msg = msg.trim();
  return ReactHtmlParser(whatsappFormat(msg));
};
